export const LOCALE_EN_CA = 'en-CA';

export function excelDateToJSDate(serial, slashed) {
    var utc_days = Math.floor(serial - 25569);
    var utc_value = utc_days * 86400;
    var date_info = new Date(utc_value * 1000);
    if (slashed) {
        return '' + date_info.getFullYear() + '-' + (date_info.getMonth() + 1) + '-' + date_info.getDate();
    }
    return '' + date_info.getDate() + (date_info.getMonth() + 1) + date_info.getFullYear();
}

export function parseDate(date, delimiter = '-') {
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    if (!year || !month || !day) {
        return ''
    }
    return `${year}${delimiter}${month < 10 ? `0${month}` : month}${delimiter}${day < 10 ? `0${day}` : day}`
}

export function getFirstDayOfQuarter(quarter, year) {
    if (!quarter || quarter < 1 || quarter > 4) return;

    const month = (quarter - 1) * 3 + 1;

    const firstDayOfQuarter = new Date(year, month - 1, 1);

    return firstDayOfQuarter;
}

export const transformPeriodToQuarterYear = (period) => {
    const quarter = 'Q' + (period % 10);
    const year = parseInt(period / 10);
    
    return quarter + ' ' + year;
}

export const isCurrentQuarter = (year, quarter) => {
    const currentDate = new Date();
    if (year < currentDate.getFullYear())
        return true;
    else if (year > currentDate.getFullYear())
        return false;
    const currentQuarter = Math.floor((currentDate.getMonth() + 3) / 3);
    return (quarter <= currentQuarter);
};

export const generateYears = (minYear, maxYear) => {
    minYear = Number(minYear.toString().substr(0, 4));
    maxYear = Number(maxYear?.toString().substr(0, 4));

    const currentYear = maxYear || (new Date()).getFullYear();
    const years = [];
    for (let i = currentYear; i >= minYear; --i) {
        years.push(i);
    }
    return years;
}

export const transformDateToQuarterPeriodInt = (date) => {
    return Number(date.getFullYear() + `${Math.ceil((date.getMonth() + 1) / 3)}`);
}

export const parseDateToISODateFormat = (date) => {
    return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
}

export const isLeapYear = (year) => {
    return (year % 4 === 0 && year % 100 !== 0) || (year % 400 === 0);
};

export const validateDateRange = (startDate, endDate) => {
    return new Date(startDate) <= new Date(endDate);
}

/**
 * Formats a Date object into a string representation.
 *
 * @param {Date} date - The Date object to be formatted.
 * @returns {string} - The formatted date string.
 *
 * @example 
 * const date = new Date(2024, 0, 1); // January 1, 2024
 * console.log(formatDate(date)); // Outputs: "Jan 1 2024"
 */
export function formatDate(date) {
    const parsedDate = typeof date === 'string' ? new Date(date) : date;
    return parsedDate.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
}


export const getReportingPeriodFormat = (startDate, endDate) => {
    const start = new Date(startDate);
    const end = new Date(endDate);
    
    // Check if it's a full year
    if (start.getMonth() === 0 && start.getDate() === 1 && 
        end.getMonth() === 11 && end.getDate() === 31 && 
        start.getFullYear() === end.getFullYear()) {
        return `${start.getFullYear()}Y`;
    }
    
    // Check if it's a half year
    if ((start.getMonth() === 0 && start.getDate() === 1 && end.getMonth() === 5 && end.getDate() === 30) ||
        (start.getMonth() === 6 && start.getDate() === 1 && end.getMonth() === 11 && end.getDate() === 31)) {
        const half = start.getMonth() === 0 ? 1 : 2;
        return `${start.getFullYear()}H${half}`;
    }
    
    // Check if it's a quarter
    const quarter = Math.floor(start.getMonth() / 3) + 1;
    const isQuarterStart = start.getDate() === 1 && 
        ((quarter === 1 && start.getMonth() === 0) ||
         (quarter === 2 && start.getMonth() === 3) ||
         (quarter === 3 && start.getMonth() === 6) ||
         (quarter === 4 && start.getMonth() === 9));
    const isQuarterEnd = end.getDate() === new Date(end.getFullYear(), end.getMonth() + 1, 0).getDate() &&
        ((quarter === 1 && end.getMonth() === 2) ||
         (quarter === 2 && end.getMonth() === 5) ||
         (quarter === 3 && end.getMonth() === 8) ||
         (quarter === 4 && end.getMonth() === 11));
    
    if (isQuarterStart && isQuarterEnd && start.getFullYear() === end.getFullYear()) {
        return `${start.getFullYear()}Q${quarter}`;
    }
    
    // Check if it's a month
    if (start.getDate() === 1 && 
        end.getDate() === new Date(end.getFullYear(), end.getMonth() + 1, 0).getDate() &&
        start.getFullYear() === end.getFullYear() &&
        start.getMonth() === end.getMonth()) {
        return `${start.getFullYear()}M${start.getMonth() + 1}`;
    }
    
    // If none of the above, return custom
    return 'Custom';
};